import './Index.css';
import './indexBase.css'
import {
    IonAvatar,
    IonContent,
    IonPage, isPlatform, setupIonicReact
} from '@ionic/react';
import React, {useState} from 'react';

const Index: React.FC = () => {

    const getConfig = () => {
        let config = {};
        if (isPlatform('iphone')) {
            config = {
                ...config,
                animated: false,
                swipeBackEnabled: false,
            };
        }
        return config;
    };

    setupIonicReact(getConfig());

    return (
        <IonPage placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonContent fullscreen placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className="gray_bg01">
                    <div className="index-cont">
                        <div className="main_cont">
                            <h1>推荐</h1>
                            <div className="game_box">
                                <div className="game_banner"><img
                                    src="https://wfw.fuyuncc.com/GameStore/134/big_banner.jpg"/></div>
                                <div className="game_list clearfix pr">
                                    <div className="game_icon fl"><img
                                        src="https://wfw.fuyuncc.com/GameStore/134/icon.png"/></div>
                                    <div className="game_tex fl"><p className="game_tex_title">快乐打地鼠<span
                                        className="tip_icon members_color">会员</span></p><p
                                        className="game_tex_p oht">简单上手，高倍奖励，画面精致！独创水果卡/宝藏等新玩法</p></div>
                                    <div className="btn pink pa md">详情</div>
                                </div>
                            </div>
                            <div className="game_box">
                                <h2>猜你喜欢</h2>
                                <div className="game_show_cont ">
                                    <ul className="game_show_1 clearfix">
                                        <ul className="game_show_1 clearfix">
                                            <li><span className="game_sh_icon"><img
                                                src="https://wfw.fuyuncc.com/GameStore/134/icon.png"/></span><p
                                                className="game_sh_tex">快乐打地鼠</p></li>
                                            <li><span className="game_sh_icon"><img
                                                src="https://wfw.fuyuncc.com/GameStore/10018/icon.png"/></span><p
                                                className="game_sh_tex">跳跃吧兔兔</p></li>
                                            <li><span className="game_sh_icon"><img
                                                src="https://wfw.fuyuncc.com/GameStore/10017/icon.png"/></span><p
                                                className="game_sh_tex">动物机车</p></li>
                                            <li><span className="game_sh_icon"><img
                                                src="https://wfw.fuyuncc.com/feedback/20221123175607525.png"/></span><p
                                                className="game_sh_tex">指尖沙场</p></li>
                                        </ul>
                                    </ul>
                                </div>
                            </div>
                            <div className="game_box">
                                <div className="game_banner2"><img
                                    src="https://wfw.fuyuncc.com/GameStore/10011/smal_lbanner.jpg"/></div>
                                <div className="game_list clearfix pr">
                                    <div className="game_icon fl"><img
                                        src="https://wfw.fuyuncc.com/GameStore/10011/icon.png"/></div>
                                    <div className="game_tex fl"><p className="game_tex_title">全民超能坦克大战<span
                                        className="tip_icon members_color">会员</span></p><p
                                        className="game_tex_p oht">感受非常刺激的战略指挥官游戏体验，让你感受全新有趣的战斗世界。</p></div>
                                    <div className="btn pink pa md">详情</div>
                                </div>
                            </div>
                            <div className="game_box">
                                <div className="game_banner2"><img
                                    src="https://wfw.fuyuncc.com/GameStore/10017/smal_lbanner.jpg"/></div>
                                <div className="game_list clearfix pr">
                                    <div className="game_icon fl"><img
                                        src="https://wfw.fuyuncc.com/GameStore/10017/icon.png"/></div>
                                    <div className="game_tex fl"><p className="game_tex_title">动物机车<span
                                        className="tip_icon free_color">免费</span></p><p
                                        className="game_tex_p oht">骑上你心爱的小摩托，快来一起竞速吧！</p></div>
                                    <div className="btn pink pa md">详情</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Index;
